import { dataSourceWholeItems } from '@/resources/data-source';
import { defineStore } from 'pinia';

export const useDataSourceStore = defineStore('data-source-store', {
  state: () => ({
    data: {} as Record<string, number>
  }),
  getters: {
    wholeValues(state) {
      return (defaultDataSource: typeof state.data | undefined) => {
        const res: Record<string, number | string> = {};
        const defaultValue = defaultDataSource ? defaultDataSource : state.data;

        dataSourceWholeItems.forEach((item) => {
          const defaultDataSourceValue =
            defaultValue?.[item.key] ??
            item.defaultValue ??
            item.value?.() ??
            0;
          res[item.key] = defaultDataSourceValue;
        });

        return res;
      };
    }
  },
  actions: {
    /**
     * 从config同步数据源默认值
     * @param data config中的数据源默认值
     * @returns
     */
    async sync(data: Record<string, number>) {
      this.data = { ...data };
    },

    /**
     * 设置数据源默认值
     * @param dataSource 数据源名称
     * @param value 数据源默认值
     * @returns
     */
    setValue(key: string, value: number) {
      this.data[key] = value;
    }
  }
});
